"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = Slider;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _vars = require("../../common/styles/vars"),
    _Text = _interopRequireDefault(require("../Text"));

require("./_slider.scss");

function getValuePercent(a, b, c) {
  var d = parseInt(c, 10);
  return 100 * ((d - a) / (b - a));
}

function setProgress(a, b, c) {
  var d = document.querySelector(".slider__input");
  d && (d.style.background = "linear-gradient(to right, ".concat(_vars.COLOURS.cyan.aqua, " 0%, ").concat(_vars.COLOURS.cyan.aqua, " ").concat(getValuePercent(a, b, c), "%, ").concat(_vars.COLOURS.grey.athens.parthenon, " ").concat(getValuePercent(a, b, c), "%, ").concat(_vars.COLOURS.grey.athens.parthenon, " 100%)"));
}

function onChangeValue(a, b, c, d) {
  return function (e) {
    var f = e.target.value;
    setProgress(c, d, f), a(f);
    b && b(f);
  };
}

function Slider(a) {
  var b = a.min,
      c = void 0 === b ? 0 : b,
      d = a.max,
      e = void 0 === d ? 100 : d,
      f = a.initialValue,
      g = void 0 === f ? 0 : f,
      h = a.labels,
      i = a.labelIntervals,
      j = void 0 === i ? 1 : i,
      k = a.getLabel,
      l = a.onChange,
      m = a.disabled,
      n = (0, _react.useState)(g < c ? c : g),
      o = (0, _slicedToArray2["default"])(n, 2),
      p = o[0],
      q = o[1],
      r = onChangeValue(q, l, c, e),
      s = (e - c) / j + 1;
  return (0, _react.useEffect)(function () {
    setProgress(c, e, p);
  }, [g]), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("slider", {
      "slider--disabled": m
    })
  }, _react["default"].createElement("input", {
    type: "range",
    min: c,
    max: e,
    value: p,
    onChange: r,
    className: "slider__input",
    disabled: m
  }), h ? _react["default"].createElement("div", {
    className: "slider__labels"
  }, (0, _toConsumableArray2["default"])(Array(s)).map(function (a, b) {
    return _react["default"].createElement("div", {
      className: "slider__labels__label",
      style: {
        left: "".concat(100 * (1 / (s - 1) * b), "%")
      }
    }, _react["default"].createElement("button", {
      className: "slider__labels__label__button",
      onClick: function onClick() {
        return r({
          target: {
            value: j * b + c
          }
        });
      }
    }, _react["default"].createElement(_Text["default"], {
      noMargin: !0,
      button: p - c >= j * b && p - c < j * b + j
    }, k && k(b) || h[b])));
  })) : null);
}